import { EventTypeUsageType } from "ui/Scripts/source/models/enums";
import { Base } from "ui/Scripts/source/framework/base";
import { IdTitleNode, IIdTitleNode } from "../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/models/common/idTitleNode";

export interface IEventTypeNode {
    id: string;
    parentId: string;
    companyId: string;
    code: string;
    comment: string;
    activeState: number;
    eventTypeUsageType: EventTypeUsageType;
    parent: IEventTypeNode;
    children: IEventTypeNode[];

    collapsed: boolean;

    isActive(): boolean;
    isSelectableForNew(): boolean;
    getAncesterIsCollapsed(): boolean;
    getEventTypeNodeById(id: string): IEventTypeNode;
    getAsList(list: IEventTypeNode[]): IEventTypeNode[];
    getAsIdTitleNode(): IIdTitleNode;
}

export class EventTypeNode implements IEventTypeNode {
    id: string;
    parentId: string;
    companyId: string;
    code: string;
    comment: string;
    activeState: number;
    eventTypeUsageType: EventTypeUsageType;
    parent: IEventTypeNode;
    children: IEventTypeNode[];

    collapsed: boolean;

    constructor();
    constructor(obj: IEventTypeNode);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.parentId = obj && obj.parentId || "";
        this.companyId = obj && obj.companyId || "";
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.activeState = obj && obj.activeState || 0;
        this.eventTypeUsageType = obj && obj.eventTypeUsageType || EventTypeUsageType.Normal;
        if (obj && obj.children) {
            this.children = Base.getTypedArray(obj.children, EventTypeNode);
            for (const child of this.children) {
                child.parent = this;
            }
        }
        this.collapsed = obj && obj.collapsed || false;
    }

    isActive(): boolean {
        let result = this.activeState > 0.5;
        if (this.parent) {
            result = result && this.parent.isActive();
        }
        return result;
    }

    isSelectableForNew(): boolean {
        let result = this.eventTypeUsageType === EventTypeUsageType.SelectForNew;
        if (this.parent) {
            result = result && this.parent.isSelectableForNew();
        }
        return result;
    }

    getAncesterIsCollapsed(): boolean {
        if (!this.parent) return false;
        if (this.parent.collapsed) return true;
        return this.parent.getAncesterIsCollapsed();
    }

    getEventTypeNodeById(id: string): IEventTypeNode {
        if (!id) return null;
        if (this.id.equalIgnoreCase(id)) return this;
        for (const child of this.children) {
            const childResult = child.getEventTypeNodeById(id);
            if (childResult) return childResult;
        }
        return null;
    }

    static getEventTypeNodeById(nodes: IEventTypeNode[], id: string): IEventTypeNode {
        if (!id || nodes.length < 1) return null;
        for (const node of nodes) {
            const result = node.getEventTypeNodeById(id);
            if (result) return result;
        }
        return null;
    }

    static removeEventTypeNodeById(nodes: IEventTypeNode[], id: string): IEventTypeNode[] {
        if (!id || nodes.length < 1) return nodes;
        for (const node of nodes) {
            const result = node.getEventTypeNodeById(id);
            if (result) {
                if (result.parent) {
                    result.parent.children = result.parent.children.filter(i => i.id !== result.id);
                    return nodes.map(i => new EventTypeNode(i));
                } else {
                    return nodes.filter(i => i.id !== result.id).map(i => new EventTypeNode(i));
                }
            }
        }
        return nodes;
    }
    
    getAsList(list: IEventTypeNode[]): IEventTypeNode[] {
        list.push(this);
        if (this.children.length < 1) return list;
        for (const child of this.children) {
            child.getAsList(list);
        }
        return list;
    }

    static getAsList(nodes: IEventTypeNode[]): IEventTypeNode[] {
        if (nodes.length < 1) return [];
        const result: IEventTypeNode[] = [];
        for (const node of nodes) {
            node.getAsList(result);
        }
        return result;
    }
    
    getAsIdTitleNode(): IIdTitleNode {
        const result = IdTitleNode.createIdTitleNode(this.id, this.code, [], this.activeState > 0);
        for (const child of this.children) {
            result.children.push(child.getAsIdTitleNode());
        }
        return result;
    }

    static getAsIdTitleNodes(nodes: IEventTypeNode[]): IIdTitleNode[] {
        if (!nodes || nodes.length < 1) return [];
        const result: IIdTitleNode[] = [];
        for (const node of nodes) {
            result.push(node.getAsIdTitleNode());
        }
        return result;
    }
}